import { render, staticRenderFns } from "./TextareaFormItem.vue?vue&type=template&id=e95040fe&"
import script from "./TextareaFormItem.vue?vue&type=script&lang=js&"
export * from "./TextareaFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports